module.exports = __webpack_public_path__ + "static/img/img_logo.af2f75f4.png";